export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/DisneyHulu/theme/components/scorecard/MetricsLabels/index.js